const ConfigurationLogTypes = {
  NOTES_TEMPLATE: "notesTemplate",
  POWERPOINT_TEMPLATE: "powerpointTemplate",
  MASTER_DATA: "masterData",
  MULTIPLE: "multiple"
} as const;

const ALL = Object.values(ConfigurationLogTypes);

export default { ...ConfigurationLogTypes, ALL };
